import { get, remove } from '@api';
import { Store } from 'react-notifications-component';
import { JOURNAL_LIMIT } from '../../constants/journal.constants';
import {
  COMMON_DATA_UPDATE_FAIL,
  COMMON_DATA_UPDATE_SUCCESS,
} from '../../constants/notification-settings';

export const FETCH_JOURNAL_TRAFFIC_START = 'FETCH_JOURNAL_TRAFFIC_START';
export const FETCH_JOURNAL_TRAFFIC_SUCCESS = 'FETCH_JOURNAL_TRAFFIC_SUCCESS';
export const FETCH_JOURNAL_TRAFFIC_FAIL = 'FETCH_JOURNAL_TRAFFIC_FAIL';

const fetchJournalTrafficStart = () => ({
  type: FETCH_JOURNAL_TRAFFIC_START,
});

export const fetchJournalTrafficSuccess = (payload) => ({
  type: FETCH_JOURNAL_TRAFFIC_SUCCESS,
  payload,
});

const fetchJournalTrafficFail = (error) => ({
  type: FETCH_JOURNAL_TRAFFIC_FAIL,
  payload: error,
});

const paramsToSearch = ({
  page,
  adminId,
  from,
  to,
  status,
}) => {
  const offset = (page || 1) * JOURNAL_LIMIT - JOURNAL_LIMIT;

  const qp = new URLSearchParams();
  qp.set('limit', JOURNAL_LIMIT);
  qp.set('offset', offset);

  if (adminId) {
    qp.set('adminId', adminId);
  }
  if (from) {
    qp.set('from', from);
  }
  if (to) {
    qp.set('to', to);
  }
  if (status) {
    qp.set('status', status);
  }

  const searchArr = [];
  qp.forEach((value, key) => {
    searchArr.push(`${key}=${value}`);
  });

  return searchArr.join('&');
};

export const fetchJournalTraffic = (params) => async (dispatch) => {
  dispatch(fetchJournalTrafficStart());
  try {
    const search = paramsToSearch(params);
    const response = await get(`/journal/traffic?${search}`);
    dispatch(fetchJournalTrafficSuccess({
      data: response.data,
      params,
    }));
  } catch (e) {
    console.error('fetchJournalTraffic error:', e);
    dispatch(fetchJournalTrafficFail(e));
  }
};

/**
 * Сериализация параметров запроса для DELETE /journal/traffic.
 * Backend принимает только from/to/adminId (период и фильтр по админу).
 * Limit/offset/status не имеют смысла для cleanup и не передаются.
 */
const clearParamsToSearch = ({ adminId, from, to }) => {
  const qp = new URLSearchParams();

  if (adminId) {
    qp.set('adminId', adminId);
  }
  if (from) {
    qp.set('from', from);
  }
  if (to) {
    qp.set('to', to);
  }

  const searchArr = [];
  qp.forEach((value, key) => {
    searchArr.push(`${key}=${value}`);
  });

  return searchArr.join('&');
};

/**
 * Очистка журнала трафика (Admin Access Log) за указанный период.
 * Backend удаляет только закрытые сессии (closed_at IS NOT NULL),
 * активные сессии сохраняются — это гарантирует серверная часть.
 */
export const clearJournalTraffic = (params, refetch, translations) => async () => {
  try {
    const search = clearParamsToSearch(params);
    const url = search ? `/journal/traffic?${search}` : '/journal/traffic';
    await remove(url);
    refetch();
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
  } catch (e) {
    console.error('clearJournalTraffic error:', e);
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
  }
};
